"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Wrench, Stethoscope, Car } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: 1,
  title: "Servicing & Repairs",
  description: "Comprehensive servicing and repairs for all makes of cars and light commercial vehicles with experienced technicians.",
  icon: Wrench
}, {
  id: 2,
  title: "Full Diagnostics",
  description: "Advanced diagnostic services to identify and resolve issues quickly, ensuring your vehicle runs smoothly.",
  icon: Stethoscope
}, {
  id: 3,
  title: "NCT Services",
  description: "Complete NCT checks and repairs to help you pass your test with confidence and peace of mind.",
  icon: Car
}];
export default function OurServices() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section id="our-services" className="dark bg-background text-foreground py-16 md:py-24">
      <div className="container max-w-[72rem] mx-auto px-6 md:px-8">
        <div className="text-center mb-12">
          <h2 className="font-display text-[36px] md:text-[48px] font-bold leading-[1.2] mb-4">
            Our Services
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Expert automotive care across three convenient locations in Wicklow
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const ServiceIcon = service.icon;
          return <div key={service.id} data-index={i} ref={refs[i] as any} className={`transition-all duration-[var(--duration-slow)] ${visibilities[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full bg-dark-section border border-white/10 hover:border-primary/40 shadow-medium hover:shadow-strong hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group">
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex items-center justify-center w-16 h-16 rounded-md bg-primary/10 text-primary group-hover:scale-110 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                      <ServiceIcon className="w-8 h-8" />
                    </div>
                    <CardTitle className="text-foreground-dark text-[24px] font-semibold">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground leading-relaxed">
                      {service.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}